import { CardAtlas } from "@/components/atoms/mock-cards/atlas";
import { CardImage } from "@/components/atoms/mock-cards/card";
import { CardImage as FullCard } from "@/components/atoms/card-view/card";

import { SortableItem } from "@/components/molecules/SortItem";
import { Box, Flex, HStack } from "styled-system/jsx";
import { Modal } from "@/components/atoms/Modal";

import { useState } from "react";
import { FullCardAtlas } from "@/components/atoms/card-view/atlas";
import { GameCard } from "@/types/card";
import { useRouter } from "next/router";
import { GameStateActions } from ".";
import { button } from "styled-system/recipes";
import {
  actCardCounterDecrement,
  actCardCounterIncrement,
  actToggleModifier,
} from "../../../utils/actions/card";

import { getCardImage } from "@/utils/getCardImage";

import { MODIFIER_TOKENS } from "@/utils/tokens/modifiers";


export const SortItemWrapper = ({
  amountOfCards = 0,
  card,
  gridIndex,
  cardIndex,
  ...props
}: {
  card: GameCard;
  gridIndex: number;
  cardIndex: number;
  amountOfCards?: number;
  setHoverImage?(slug?: string): void;
} & GameStateActions) => {
  function over() {
    if (props.setHoverImage) props.setHoverImage(card.img);
  }
  function out() {
    if (props.setHoverImage) props.setHoverImage();
  }

  const { query } = useRouter();
  const name = query?.name as string;

  // opens modal with card actions
  const [preview, setPreview] = useState(false);

  // Adjusts the height of card based on amount in cell
  const heightCalc = () => {
    if (amountOfCards === 1) return 120;
    if (amountOfCards === 2) return 75;
    if (amountOfCards === 3) return 51;
    if (amountOfCards === 4) return 39;
    return 90 - Math.min(amountOfCards, 4) * 15;
  };

  // Adjusts the height of tokens based on amount of cardsin cell
  const tokenSize = () => {
    if (amountOfCards <= 1) return { w: 44, h: 57 };
    if (amountOfCards === 2) return { w: 31, h: 44 };
    if (amountOfCards === 3) return { w: 27, h: 37 };
    if (amountOfCards === 4) return { w: 23, h: 34 };
    return { w: 18, h: 25 };
  };

  const height = `${heightCalc()}px`;

  const { w, h } = tokenSize();

  const isTapped = card.isTapped;
  function toggleTap() {
    const newGrid = [...props.gridItems];
    const card = newGrid[gridIndex][cardIndex];
    newGrid[gridIndex][cardIndex] = {
      ...card,
      isTapped: !card.isTapped,
    } as GameCard;
    props.setGridItems(newGrid);
  }

  // function incrementCounter() {
  //   actCardCounterIncrement(props.gridItems, gridIndex, cardIndex);
  // }

  // function decrementCounter() {
  //   actCardCounterDecrement(props.gridItems, gridIndex, cardIndex);
  // }

  function incrementCounter() {
    props.setGridItems(actCardCounterIncrement(props.gridItems, gridIndex, cardIndex));
  }

  function decrementCounter() {
    props.setGridItems(actCardCounterDecrement(props.gridItems, gridIndex, cardIndex));
  }

  // function toggleWard() {
  //   props.setGridItems(
  //     actToggleWard(props.gridItems, gridIndex, cardIndex),
  //   );
  // }

  function toggleModifier(key: (typeof MODIFIER_TOKENS)[number]["key"]) {
    props.setGridItems(
      actToggleModifier(props.gridItems, gridIndex, cardIndex, key),
    );
  }

  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setPreview(true);
      }}
    >
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleTap();
        }}
        onMouseOver={over}
        onMouseOut={out}
        data-testid={"sortable-item-wrapper-" + card.id}
        style={{
          height: heightCalc() + 7 + "px",
          transform: isTapped ? "rotate(5deg)" : "",
          filter: isTapped ? "saturate(0)" : "",
          transition: "all 0.25s ease",
          position: "relative",
        }}
      >

        <SortableItem
          key={`card-${gridIndex}-${cardIndex}`}
          data-testid={"sortable-item-" + card.id}
          id={card.id}
          gridIndex={gridIndex}
          index={cardIndex}
        >
          {/* Keep this wrapper minimal and DON'T change CardImage/CardAtlas DOM */}
          <div style={{ position: "relative", width: "100%", height: "100%" }}>
            {/* Card art */}
            {card.type === "site" ? (
              <CardAtlas
                height={height}
                img={card.img}
                isMine={name === card.playerName}
              />
            ) : (
              <CardImage
                height={height}
                img={card.img}
                isMine={name === card.playerName}
              />
            )}

            {/* Counter overlay */}
            {card.counter && card.counter !== 0 ? (
              <Box
                position="absolute"
                right="8px"
                bottom="1px"
                zIndex={21}
                bg="rgba(40, 37, 37, 0.82)"
                backdropFilter="blur(4px)"
                filter="drop-shadow(0 1px 1px black)"
                p="0.25rem 0.75rem"
                borderRadius="100%"
                color="white"
                minW="1.65rem"
                pointerEvents="none"
              >
                <p style={{ fontSize: "0.75rem", fontWeight: "900" }}>{card.counter}</p>
              </Box>
            ) : null}

            {/* Ward overlay */}
            {/* {card.modifiers?.ward ? (
              <Box
                position="absolute"
                left="8px"
                bottom="0px"
                zIndex={21}
                px="0.35rem"
                py="0.2rem"
                borderRadius="0.5rem"
                bg="rgba(0,0,0,0.45)"
                backdropFilter="blur(2px)"
                filter="drop-shadow(0 1px 1px black)"
                pointerEvents="none"
              >
                <img
                  src={getCardImage("token:ward")}
                  alt="Ward"
                  style={{
                    width: "17px",
                    height: "25px",
                    objectFit: "contain",
                    display: "block",
                    borderRadius: "0.25rem",
                  }}
                />
              </Box>
            ) : null} */}

            {card.modifiers ? (
              <Box
                position="absolute"
                left="10px"
                bottom="2px"
                zIndex={21}
                display="flex"
                gap="4px"
                pointerEvents="none"
              >
                {MODIFIER_TOKENS.filter((m) => card.modifiers?.[m.key]).map((m) => (
                  <Box
                    key={m.key}
                    px="0.15rem"
                    py="0.15rem"
                    borderRadius="0.4rem"
                    bg="rgba(0,0,0,0.45)"
                    backdropFilter="blur(2px)"
                    filter="drop-shadow(0 2px 2px black)"
                  >

                <img
                  src={getCardImage(`token:${m.icon}`)}
                  alt={m.name}
                  title={m.name}
                  style={{
                    width: `${w}px`,
                    height: `${h}px`,
                    objectFit: "contain",
                    display: "block",
                  }}
                />
                  </Box>
                ))}
              </Box>
            ) : null}

          </div>
        </SortableItem>

      </div>
      <Modal
        wrapperProps={{ open: preview, onOpenChange: setPreview }}
        content={
          <Flex direction="column" gap="1rem">

            <Box h="600px" w="460px" position="relative">
              {card.type === "site" && <FullCardAtlas img={card.img} />}
              {card.type !== "site" && <FullCard img={card.img} />}
            </Box>

            <HStack justifyContent="center">
              <p>Counter: </p>
              <button className={button()} onClick={decrementCounter}>
                - 1
              </button>
              <p>{card.counter}</p>

              <button className={button()} onClick={incrementCounter}>
                + 1
              </button>

              {/* <button className={button()} onClick={toggleWard}>
                Ward: {card.modifiers?.ward ? "On" : "Off"}
              </button> */}
            </HStack>

            <HStack justifyContent="center" flexWrap="wrap" gap="0.5rem">
                {MODIFIER_TOKENS
                  .filter((m) =>
                    m.allowed.includes(card.type === "site" ? "site" : "minion"),
                  )
                  .map((m) => (
                    <button
                      key={m.key}
                      className={button()}
                      onClick={() => toggleModifier(m.key)}
                      style={{
                        fontSize: "1rem",
                        padding: "0.2rem 0.5rem",
                        borderRadius: "15px",
                        border: "0px solid rgba(107, 107, 106, 0.85)",
                        background: card.modifiers?.[m.key]
                          ? m.colorON   // black ON
                          : "rgba(99, 99, 99, 0.25)", // grayed out OFF
                        color: "white",
                        cursor: "pointer",
                        transition: "all 0.15s ease",
                      }}
                    >
                      {m.name}
                      {/* : {card.modifiers?.[m.key] ? "On" : "Off"} */}
                    </button>
                  ))}
              </HStack>

          </Flex>
        }
      />
    </div>
  );
};
